import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchReportingCycles } from "../api/reportingCycle.api";

const useReportingCycle = ({ companyId, enabled }) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  // Fetch reporting cycle data
  const {
    data: reportingCycleData,
    error: reportingCycleError,
    isLoading: isLoadingReportingCycle,
    isSuccess: isReportingCycleSuccess,
  } = useQuery({
    queryKey: ["reportingCycle", companyId],
    queryFn: () => fetchReportingCycles(bearerToken as string, companyId),
    enabled: !!enabled,
  });

  return {
    reportingCycleData,
    reportingCycleError,
    isLoadingReportingCycle,
    isReportingCycleSuccess,
  };
};

export default useReportingCycle;
